import React from 'react'

/**
 * Overlay visual durante drag & drop
 * 
 * Single Responsibility: Feedback visual de drag
 */
export default function DragOverlay({ visible }) {
  if (!visible) return null

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(79, 70, 229, 0.1)',
      border: '3px dashed #4f46e5',
      zIndex: 1000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      pointerEvents: 'none'
    }}>
      <div style={{
        padding: '2rem 3rem',
        backgroundColor: 'white',
        borderRadius: '1rem',
        boxShadow: '0 10px 40px rgba(0,0,0,0.15)'
      }}>
        <p style={{ margin: 0, fontSize: '1.25rem', color: '#4f46e5', fontWeight: 500 }}>
          📎 Solte os arquivos aqui
        </p>
      </div>
    </div>
  )
}
